/*
localized-options-service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/localized-options-service',[
    '../module'
], function (module) {
    'use strict';

    module.service('localizedOptions', ['getLocaleService', function (getLocaleService) {
        var localizedOptions = {
            datepickerFormat: 'dd M yy',
            datepickerFormat_ja: 'yy年mm月dd日'
        };

        var getLocalizedOption = function(key) {
            return localizedOptions[key + '_' + getLocaleService.getLocale()] || localizedOptions[key];
        };

        return {
            getDatepickerFormat: _.partial(getLocalizedOption, 'datepickerFormat')
        };
    }]);
});

